/* eslint-disable no-console */
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { cacheAdapterEnhancer } from 'axios-extensions'

Vue.use(VueAxios, axios)

const path = window.location.hostname.indexOf('droitsdelapersonne') > -1 ? 'passezalaction' : 'upstander'

const http = Vue.axios.create({
    baseURL: '/' + path + '/api/v2',
	headers: { 'Cache-Control': 'no-cache' },
    adapter: cacheAdapterEnhancer(axios.defaults.adapter),
    crossDomain: true
})

export default {
    getPageItems () {
        return  http.get('/pages/4/')
            .then(response => {
                return response
            })
    },
    getTeacherGuideItems () {
        return http.get('/pages/5/')
            .then(response => {
                return response
            })
    }
}